<div class="edd-del" >
    <mat-icon  *ngIf="assignAction?.Write && announcmentStatus == 'send'">done</mat-icon>
    <mat-icon (click)="edit($event)" *ngIf="assignAction?.Write && emailIdNew && announcmentStatus == 'draft'">edit</mat-icon>
    <mat-icon (click)="edit($event)" *ngIf="assignAction?.Write && !emailIdNew">edit</mat-icon>
    <mat-icon (click)="calculateRatio($event)" *ngIf="assignAction?.Write &&openHouseTraining">aspect_ratio</mat-icon>

    <ng-container *ngIf="assignAction?.Delete">
        <mat-icon (click)="delete($event)" *ngIf="!openHouseTraining">delete</mat-icon>
    </ng-container>
    <ng-container *ngIf="assignAction?.Read">
        <mat-icon *ngIf="!openHouseTraining">visibility</mat-icon>
    </ng-container>
    <!-- <button mat-raised-button color="primary">Primary</button>
    <button mat-raised-button color="warn">Warn</button> -->
</div>
